export const getAmount = state => state.paymentR.amount;
export const getStatus = state => state.paymentR.status;
export const getError = state => state.paymentR.error;
export const getLoading = state => state.paymentR.loading;
export const getEncriptAmount = state => state.paymentR.encriptAmount;

export const getAdyenSession = state => state.paymentR.adyenSession
export const getAdyenConfiguration = state => state.paymentR.adyenConfiguration